/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC, useEffect, useContext } from 'react';
import { LanguageContext } from 'context/languageContext';

import {
  MainContainer,
  MainPageVideoContainer,
  ReferralBonusContainer,
  AgentStatusContainer,
  // ComfortBonusContainer,
  VideoCallContainer,
  WorkAllDeviceContainer,
  PopularQuestionsContainer,
  ContactUsContainer,
} from 'containers';
import { Footer } from 'components';

import styles from './styles.module.scss';

interface IHomePage {
  goingFooter?: boolean;
}

export const HomePage: FC<IHomePage> = ({ goingFooter }) => {
  useEffect(() => {
    if (goingFooter) {
      setTimeout(() => {
        window.scrollTo(0, document.body.scrollHeight);
      }, 500);
    }
  }, [goingFooter]);

  const { currentLanguage } = useContext(LanguageContext);

  return (
    <div className={styles.main_page}>
      <div className={styles.main_page_container}>
        <MainContainer />
        <MainPageVideoContainer language={currentLanguage} />
        <AgentStatusContainer />
        <ReferralBonusContainer />
        {/* <ComfortBonusContainer /> */}
        <VideoCallContainer />
        <WorkAllDeviceContainer />
        <PopularQuestionsContainer />
        <ContactUsContainer />
      </div>
      <Footer />
    </div>
  );
};
